function game_1006()
{

}
game_1006.read_odd = function(id)
{
  if(id === 1)
  {
    return "2";
  }
  else if(id === 2)
  {
    return "2";
  }
  else if(id === 3)  {
    return "3";
  }
  else if(id === 4)  {
    return "4";
  }
  else if(id === 5){
    return "5";
  }
  else if(id === 6){
    return "6";
  }
  else if(id === 7){
    return "7";
  }
  else if(id === 8){
    return "8";
  }
  else if(id === 9){
    return "9";
  }
  else if(id === 10){
    return "10";
  }
  else if(id === 11){
    return "12";
  }
  else if(id === 12){
    return "15";
  }
  else if(id === 13){
    return "18";
  }
  else if(id === 14){
    return "20";
  }
  else if(id === 15){
    return "25";
  }
  else if(id === 50){
    return "30";
  }
  else if(id === 51){
    return "35";
  }
  else if(id === 52){
    return "100";
  }
  else if(id === 53){
    return "100-300";
  }
  else if(id === 54){
    return "320";
  }
  else if(id === 55){
    return "320-500";
  }
  else if(id === 56){
    return "10";
  }
  else if(id === 57){
    return "10";
  }
  else if(id === 59){
    return "20";
  }
  else if(id === 60){
    return "12";
  }
  else if(id === 61){
    return "15";
  }
  else if(id === 62){
    return "21";
  }
  else if(id === 71){
    return "24";
  }
  else if(id === 72){
    return "32";
  }
  else if(id === 73){
    return "40";
  }
  else if(id === 81){
    return "2";
  }
  else if(id === 82){
    return "2";
  }
  else if(id === 83){
    return "3";
  }
  else if(id === 84){
    return "4";
  }
  else if(id === 85){
    return "5";
  }
  else if(id === 86){
    return "6";
  }
  else if(id === 87){
    return "7";
  }
  else if(id === 88){
    return "8";
  }
  else if(id === 89){
    return "9";
  }
  else if(id === 90){
    return "10";
  }
  else if(id === 91){
    return "12";
  }
  else if(id === 92){
    return "15";
  }
  else if(id === 93){
    return "18";
  }
  else if(id === 94){
    return "20";
  }
  else if(id === 95){
    return "25";
  }
  else if(id === 99){
    return "50-200";
  }


    return  "";
}

export {
  game_1006
};



// WEBPACK FOOTER //
// ./src/components/fish/game_1006.js